import React from "react";
import Nav from "../Components/Nav";
import Footer from "../Components/Footer";
import "./index.less";
import { useTranslation } from "react-i18next";

export default function Story() {
    const { t } = useTranslation();

    return (
        <div className="story-page">
            <Nav/>
            <div className="hero-section">
                <div className="hero-bg"/>
                <div className="hero-overlay"/>
                <div className="hero-content">
                    <h1 className="hero-title">{t('story.title')}</h1>
                    <p className="hero-subtitle">{t('story.subtitle')}</p>
                </div>
            </div>
            <div className="main-content">
                <div className="content-wrapper">
                    <div className="story-timeline">
                        <div className="timeline-item">
                            <div className="timeline-marker">
                                <div className="marker-dot"/>
                                <div className="marker-line"/>
                            </div>
                            <div className="timeline-content">
                                <div className="timeline-year">{t('story.section1.year')}</div>
                                <h2 className="timeline-title">{t('story.section1.title')}</h2>
                                <p className="timeline-text">{t('story.section1.content')}</p>
                            </div>
                        </div>

                        <div className="timeline-item">
                            <div className="timeline-marker">
                                <div className="marker-dot"/>
                                <div className="marker-line"/>
                            </div>
                            <div className="timeline-content">
                                <div className="timeline-year">{t('story.section2.year')}</div>
                                <h2 className="timeline-title">{t('story.section2.title')}</h2>
                                <p className="timeline-text">{t('story.section2.content')}</p>
                            </div>
                        </div>

                        <div className="timeline-item">
                            <div className="timeline-marker">
                                <div className="marker-dot"/>
                            </div>
                            <div className="timeline-content">
                                <div className="timeline-year">{t('story.section3.year')}</div>
                                <h2 className="timeline-title">{t('story.section3.title')}</h2>
                                <p className="timeline-text">{t('story.section3.content')}</p>
                            </div>
                        </div>
                    </div>

                    <div className="story-values">
                        <div className="values-header">
                            <span className="values-line"/>
                            <h2>{t('story.values.title')}</h2>
                            <span className="values-line"/>
                        </div>
                        <div className="values-grid">
                            <div className="value-card">
                                <div className="value-icon">
                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </div>
                                <h3 className="value-title">{t('story.values.quality')}</h3>
                                <p className="value-description">{t('story.values.qualityDesc')}</p>
                            </div>
                            <div className="value-card">
                                <div className="value-icon">
                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M12 16V12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M12 8H12.01" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </div>
                                <h3 className="value-title">{t('story.values.service')}</h3>
                                <p className="value-description">{t('story.values.serviceDesc')}</p>
                            </div>
                            <div className="value-card">
                                <div className="value-icon">
                                    <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M3 21H21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M5 21V7L12 3L19 7V21" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                        <path d="M9 10L10.5 11.5L15 7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </div>
                                <h3 className="value-title">{t('story.values.innovation')}</h3>
                                <p className="value-description">{t('story.values.innovationDesc')}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
    );
}
